import React from "react";
import clsx from "clsx";
import Assets from "imports/assets.import";
import { STRINGS } from "constants/strings.constant";
import { PropertiesEmptyStateProps } from "interfaces/properties_empty_state.interface";
import "./properties_empty_state.component.scss";

// The Properties column before there is anything to show properties for: says what will appear
// there and what makes a target image track well.
const PropertiesEmptyState = (props: PropertiesEmptyStateProps) => {
    const { className } = props;
    const strings = STRINGS.editor.propertiesEmptyState;

    return (
        <aside className={clsx("properties_empty_state", className)}>
            <div className="properties_empty_state__header">
                <span className="properties_empty_state__eyebrow">{strings.eyebrow}</span>
                <p className="properties_empty_state__hint">{strings.hint}</p>
            </div>
            <div className="properties_empty_state__tips">
                <h3 className="properties_empty_state__tips_title">{strings.tipsTitle}</h3>
                <ul className="properties_empty_state__tips_list">
                    {strings.goodTips.map((tip) => (
                        <li key={tip} className="properties_empty_state__tip">
                            <img src={Assets.check_lime} alt={strings.goodIconAlt} />
                            <span>{tip}</span>
                        </li>
                    ))}
                    <li className="properties_empty_state__tip">
                        <img src={Assets.cross_muted} alt={strings.badIconAlt} />
                        <span>{strings.badTip}</span>
                    </li>
                </ul>
            </div>
        </aside>
    );
};

export default PropertiesEmptyState;
